module.exports = __webpack_public_path__ + "media/images/states/ga-red-4c6383efa58b21d405a0bf8819c7f49c.png";